<div class="mx-7 fs-16 fw-600">
    {{ 'timer.end.of.session' | translate }}
    <div class="timer">{{ (time$ | async)! | countdownFormat }}</div>
</div>
